import React, { useCallback, useEffect, useState } from 'react'

import { getAllItemRequestsForAdmin } from '@/redux/states/admin/orders/getAllItemRequestsForAdmin/getAllItemRequestsForAdmin.slice'
import { GetAllItemRequestsForAdminRequestPayload } from '@/redux/states/admin/orders/getAllItemRequestsForAdmin/getAllItemRequestsForAdmin.types'
import { getOfferRequestPaymentDetailsForAdmin } from '@/redux/states/admin/orders/getOfferRequestPaymentDetailsForAdmin/getOfferRequestPaymentDetailsForAdmin.slice'
import { GetOfferRequestPaymentDetailsForAdminRequestPayload } from '@/redux/states/admin/orders/getOfferRequestPaymentDetailsForAdmin/getOfferRequestPaymentDetailsForAdmin.types'
import { getOfferRequestTripDetailsForAdmin } from '@/redux/states/admin/orders/getOfferRequestTripDetailsForAdmin/getOfferRequestTripDetailsForAdmin.slice'
import { GetOfferRequestTripDetailsForAdminRequestPayload } from '@/redux/states/admin/orders/getOfferRequestTripDetailsForAdmin/getOfferRequestTripDetailsForAdmin.types'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'

import Table from '../../../../shared/components/Table/Table.component'

import env from '../../../../networkRequests/apiClient/env.config'
import { getAllOfferRequestsForAdmin } from '../../../../redux/states/admin/orders/getAllOfferRequestsForAdmin/getAllOfferRequestsForAdmin.slice'
import {
  GetAllOfferRequestsForAdminOfferRequest,
  GetAllOfferRequestsForAdminRequestPayload
} from '../../../../redux/states/admin/orders/getAllOfferRequestsForAdmin/getAllOfferRequestsForAdmin.types'
import { RootState } from '../../../../redux/store/store.types'
import { useAppDispatch } from '../../../../shared/hooks/redux.hooks'
import { adminNavigationPaths } from '../../AdminDashboard.dictionary'
import { offerRequestTableColumns } from './OfferRequests.dictionary'
import styles from './OfferRequests.styles'
import { OfferRequestsProps } from './OfferRequests.types'

const OfferRequests: React.FC<OfferRequestsProps> = (props) => {
  const { searchQuery, demoRouter, setSelectedUser } = props

  const [offerRequestsPage, setOfferRequestsPage] = useState(1)
  const [offerRequestsTotalPages, setOfferRequestsTotalPages] = useState(1)
  const [offerRequestsTotalRecords, setOfferRequestsTotalRecords] = useState(0)
  const [offerRequestsData, setOfferRequestsData] = useState<GetAllOfferRequestsForAdminOfferRequest[]>([])

  const pageSize = env.DEFAULT_PAGE_SIZE
  const dispatch = useAppDispatch()

  const {
    loading: offerRequestsLoading,
    success: offerRequestsSuccess,
    error: offerRequestsError
  } = useSelector((state: RootState) => state.getAllOfferRequestsForAdmin)

  useEffect(() => {
    if (offerRequestsSuccess?.data) {
      const { currentPage, totalPages, totalRecords, records } = offerRequestsSuccess.data

      setOfferRequestsTotalPages(totalPages)
      setOfferRequestsTotalRecords(totalRecords)
      setOfferRequestsPage(currentPage)
      setOfferRequestsData(records)
    }
  }, [offerRequestsSuccess])

  const handleGetOfferRequests = useCallback(
    (page: number = 1, size: number = pageSize, onSuccess?: () => void) => {
      const payload: GetAllOfferRequestsForAdminRequestPayload = {
        request: {
          page,
          size,
          searchQuery
        },
        onSuccess
      }

      dispatch(getAllOfferRequestsForAdmin(payload))
    },
    [dispatch, searchQuery, pageSize]
  )

  useEffect(() => {
    handleGetOfferRequests()
  }, [handleGetOfferRequests])

  const handleGetOfferRequestDetailsForAdmin = useCallback(
    (page: number = 1, size: number = pageSize, offerRequestId: number, userId: string) => {
      setOfferRequestsPage(page)

      const itemRequestPayload: GetAllItemRequestsForAdminRequestPayload = {
        request: { page, size, offerRequestId }
      }

      const paymentDetailsPayload: GetOfferRequestPaymentDetailsForAdminRequestPayload = {
        request: { offerRequestId }
      }

      const tripDetailsPayload: GetOfferRequestTripDetailsForAdminRequestPayload = {
        request: { offerRequestId }
      }

      demoRouter.navigate(`/${adminNavigationPaths.offerRequests}/${userId}/Orders/${offerRequestId}`)
      dispatch(getAllItemRequestsForAdmin(itemRequestPayload))
      dispatch(getOfferRequestPaymentDetailsForAdmin(paymentDetailsPayload))
      dispatch(getOfferRequestTripDetailsForAdmin(tripDetailsPayload))
    },
    [dispatch, demoRouter, pageSize]
  )

  return (
    <Box sx={styles.container}>
      <Table
        columns={offerRequestTableColumns}
        data={offerRequestsData}
        pagination={{
          currentPage: offerRequestsPage,
          totalPages: offerRequestsTotalPages,
          totalRecords: offerRequestsTotalRecords,
          onNext: () => handleGetOfferRequests(offerRequestsPage + 1),
          onPrevious: () => handleGetOfferRequests(offerRequestsPage - 1)
        }}
        initialLoading={offerRequestsLoading}
        error={!!offerRequestsError}
        onRetry={() => handleGetOfferRequests()}
        onRowClick={(_, index) => {
          const offerRequestId = offerRequestsData[index].id
          const user = offerRequestsData[index].shopper
          const userId = user.id.toString()

          setSelectedUser(user)

          if (offerRequestId) {
            handleGetOfferRequestDetailsForAdmin(1, pageSize, offerRequestId, userId)
          }
        }}
        inPage
      />
    </Box>
  )
}

export default OfferRequests
